import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';

const DealerAcknowledgement: React.FC = () => {
    const { creditAppPrintInstructions } = useLocalization();
    return (
        <>
            <hr />
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item u-1/1 print_instruction_wrapper'>
                        <p className='heading bold'>
                            {creditAppPrintInstructions.FIRST_STEP_HEADER}
                        </p>
                        <p className=''>
                            {creditAppPrintInstructions.FIRST_STEP_DESCRIPTION}
                        </p>
                        <p className='heading bold'>
                            {creditAppPrintInstructions.NEXT_STEP_HEADER}
                        </p>
                        <p className=''>
                            {creditAppPrintInstructions.NEXT_STEP_DESCRIPTION}
                        </p>
                        <p className='heading bold'>
                            {creditAppPrintInstructions.FINAL_STEP_HEADER}
                        </p>
                        <p className='sub_heading bold'>
                            {creditAppPrintInstructions.FINAL_STEP_SUB_HEADER}
                        </p>
                        <p className=''>
                            {creditAppPrintInstructions.FINAL_STEP_DESCRIPTION}
                            <br />
                            <span className='bold'>
                                {
                                    creditAppPrintInstructions.FINAL_STEP_ACK_STATEMENT
                                }
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DealerAcknowledgement;
